import { type ComponentType } from 'react'
import { isPlainObject } from '../mergePatch'
import { IphTemplateValueLabel, IphTemplateWidget } from './IphTemplateWidget'
import { TemplateLibraryValueLabel, TemplateLibraryWidget } from './TemplateLibraryWidget'
import { MediaFileValueLabel, MediaFileWidget } from './MediaFileWidget'
import { MeetingTemplateValueLabel, MeetingTemplateWidget } from './MeetingTemplateWidget'

export interface ZocksReferenceWidgetProps {
  value: string
  onChange: (value: string | undefined) => void
  disabled: boolean
  required: boolean
  label: string
  config: Record<string, unknown>
  layer: 'account' | 'user'
  id: string
  setFieldUploading?: (fieldId: string, uploading: boolean) => void
  excludeIds?: string[]
}

export interface ReferenceValueLabelProps {
  value: string
  config: Record<string, unknown>
  layer: 'account' | 'user'
  fallback: string
}

export interface ReferenceKind {
  Widget: ComponentType<ZocksReferenceWidgetProps>
  ValueLabel: ComponentType<ReferenceValueLabelProps>
}

export const referenceKinds: Record<string, ReferenceKind> = {
  'input-parameters': { Widget: IphTemplateWidget, ValueLabel: IphTemplateValueLabel },
  'template-library': { Widget: TemplateLibraryWidget, ValueLabel: TemplateLibraryValueLabel },
  'media-file': { Widget: MediaFileWidget, ValueLabel: MediaFileValueLabel },
  'meeting-template': { Widget: MeetingTemplateWidget, ValueLabel: MeetingTemplateValueLabel },
}

export const referenceKindOf = (kind: unknown): ReferenceKind | undefined =>
  typeof kind === 'string' && Object.hasOwn(referenceKinds, kind) ? referenceKinds[kind] : undefined

export const referenceConfigOf = (annotation: unknown): Record<string, unknown> =>
  isPlainObject(annotation) ? Object.fromEntries(Object.entries(annotation).filter(([key]) => key !== 'kind')) : {}
